import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { updateFixtureOrder } from '../../Redux/Slicers/Fixtures/UpdateFixtureOrderSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import { updateSlotOrder } from '../../Redux/Slicers/Slot/UpdateSlotOrderSlicer';
import { updateSpaceOrder } from '../../Redux/Slicers/Space/UpdateSpaceOrderSlicer';

interface Item {
  zone_id: string;
  space_id: number;
  parking_type: { name: string };
  x: string;
  y: string;
  index: string;
}

interface TableProps {
  rows: Item[];
  columns: string[];
}

const SpaceOrder: React.FC<any> = ({ rows, onSubmit }) => {
  console.log(rows);

  const dispatch = useAppDispatch();
  const [items, setItems] = useState<Item[]>(rows);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const { data: updateSlotOrders } = useAppSelector(
    (state: any) => state?.UpdateSlotOrder
  );
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(true);
    console.log(updateSlotOrders);
  }, [updateSlotOrders]);
  //   console.log(updateFixtureOrders);

  // Handle drag start
  const handleDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  // Allow drop
  const handleDragOver = (e: React.DragEvent<HTMLTableRowElement>) => {
    e.preventDefault();
  };

  // Handle drop event
  const handleDrop = (index: number) => {
    if (draggedIndex === null || draggedIndex === index) return;

    const updatedItems = [...items];
    const [draggedItem] = updatedItems.splice(draggedIndex, 1);
    updatedItems.splice(index, 0, draggedItem);

    const reorderedItems = updatedItems.map((item, idx) => ({
      ...item,
      order: idx + 1,
    }));

    setItems(reorderedItems);
    setDraggedIndex(null);
  };

  // Handle row click to select the item
  const handleRowClick = (index: number) => {
    setSelectedIndex(index);
  };

  const handleButtonClick = () => {
    // setOpen(true);
    dispatch(updateSpaceOrder(items));
    console.log(items);
  };

  return (
    <>
      <div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Zone
              </th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Space
              </th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Type
              </th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                X
              </th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Y
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={item.index}
                draggable
                onDragStart={() => handleDragStart(index)}
                onDragOver={handleDragOver}
                onDrop={() => handleDrop(index)}
                onClick={() => handleRowClick(index)}
                style={{
                  cursor: 'move',
                  backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff', // Highlight selected row
                }}>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.zone_id}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.space_id}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.parking_type.name}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.x}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.y}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Button
          className="add_button"
          onClick={handleButtonClick}
          style={{ marginTop: '10px', width: '113px', marginLeft: '100px' }}>
          Submit
        </Button>
      </div>
    </>
  );
};

export default SpaceOrder;
